var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCybersecuritys(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 10.8333C16.6666 15 13.75 17.0833 10.2833 18.2917C10.1018 18.3532 9.90459 18.3502 9.72498 18.2833C6.24998 17.0833 3.33331 15 3.33331 10.8333V5C3.33331 4.77898 3.42111 4.56702 3.57739 4.41074C3.73367 4.25446 3.94563 4.16666 4.16665 4.16666C5.83331 4.16666 7.91665 3.16666 9.36665 1.9C9.54319 1.74916 9.76777 1.66629 9.99998 1.66629C10.2322 1.66629 10.4568 1.74916 10.6333 1.9C12.0916 3.175 14.1666 4.16666 15.8333 4.16666C16.0543 4.16666 16.2663 4.25446 16.4226 4.41074C16.5788 4.56702 16.6666 4.77898 16.6666 5V10.8333Z",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCybersecuritys);
export default __webpack_public_path__ + "static/media/Cybersecuritys.d2e17cbb7c7b722c90c175ac031810d0.svg";
export { ForwardRef as ReactComponent };